import scribenzaLogo from '@/assets/scribenza-logo.png'
import scribenzaMark from '@/assets/scribenza-mark.png'
import { useThemeStore } from '@/store/themeStore'

/**
 * @param {'wordmark'|'mark'} variant  'wordmark' is the full 4.3:1 logo.
 *   'mark' is the square "Sc" glyph, padded inside its own canvas — use it
 *   anywhere the space is square. The collapsed sidebar previously rendered
 *   the wordmark with object-cover, which cropped it at the container edge
 *   and read as a rendering fault rather than a deliberate mark (QA filed it
 *   twice). Both are generated from the same artwork, so they stay in step.
 */
export default function ScribenzaLogo({ alt = 'Scribenza', adaptToLightTheme = false, variant = 'wordmark', className, style }) {
  const theme = useThemeStore(s => s.theme)
  const src = variant === 'mark' ? scribenzaMark : scribenzaLogo

  const themeStyle = adaptToLightTheme && theme === 'light'
    ? {
        filter: 'brightness(0.46) saturate(1.35) contrast(1.18)',
      }
    : null

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ ...style, ...themeStyle }}
    />
  )
}
